import * as S from './FeedbackMessage.styles';

const FeedbackMessage = ({ children }) => {
  return <S.FeedbackMessage>{children}</S.FeedbackMessage>;
};

export default FeedbackMessage;
